import React, { Children } from 'react';
import styled from 'styled-components';
const StyledContainer = styled.div `
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.333333333rem;
`;
const StyledChildWrapper = styled.div `
  &:not(:last-child) > * {
    border-right: 0;
  }
`;
const renderChildren = (children) => Children.map(children, (child) => {
    if (!React.isValidElement(child)) {
        return child;
    }
    return (React.createElement(StyledChildWrapper, null,
        React.createElement(child.type, Object.assign({}, child.props))));
});
const CombinedBadge = ({ children, className, onClick, }) => (React.createElement(StyledContainer, { className: className, onClick: onClick }, renderChildren(children)));
export default CombinedBadge;
